<template>
  <a-steps :current="current">
    <a-step>
      <template #title>
        第1步: <span>获取商品数据</span>
      </template>
    </a-step>
    <a-step>
      <template #title>
        第2步: <span>预览商品数据</span>
      </template>
    </a-step>
    <a-step>
      <template #title>
        第3步: <span>开始铺货</span>
      </template>
    </a-step>
  </a-steps>
</template>
<script>
export default {
  props: {
    current: Number
  }
}
</script>